<template>
    <div>
        <div>
            <v-card class="pl-4 pr-4 mb-4">
                <v-card-title>
                    <v-spacer></v-spacer>
                    <label>Coming Soon</label>
                    <v-spacer></v-spacer>
                </v-card-title>
            </v-card>
        </div>
    </div>
</template>

<script>

export default {
    name: "Settings Manager",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {
    },
};
</script>
